module.exports = __webpack_public_path__ + "media/images/favicon-f6f63b386bf20571545c2f0405b2bc97.png";